import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação do Router
import {Redirect} from 'react-router-dom';

class MaterialsEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      id: this.props.material_id,
      name: this.props.material_data.name,
    };

    //bind específico
    this.editar = this.editar.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.name === 'undefined') {
      this.setState({
        id: newProps.material_id,
        name: newProps.material_data.name,
      });
    }
  }

  // Fetch salvando a edição
  editar(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/material', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title pull-left">Dados do material</h3>
  <div className="clearfix"></div>
  <hr/>
  <form onSubmit={this.editar}>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Nome:</label>
          <input type="text" name="name" className="form-control" placeholder="Nome do material" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
        </div>
      </div>
      <div className="col-md-6">
        <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Editar material</button>
      </div>
    </div>
  </form>
</div>
    );
  }
}

export default MaterialsEditTab;



// WEBPACK FOOTER //
// ./src/Components/Materials/Elements/MaterialsEditTab.js